// Module
var code = `<div class="documents content-margin">
    <div class="flex-vertical absolute-fill">
        <div class="flex-header">
            <div class="clearfix">
                <div class="btn-group-label" data-bind="css: { active: selectedItemsCount }, requiredAccess: 'DatabaseAdmin'" data-label="Selection" role="group">
                    <button type="button" class="btn btn-danger" data-bind="click: deleteSelected, css: { 'btn-spinner': spinners.delete() }, enable: deleteEnabled">
                        <span class="icon-trash"></span> <span>Delete</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="flex-grow scroll">
            <div class="scroll-stretch">
                <div class="panel">
                    <virtual-grid class="resizable documents-grid" params="controller: gridController, emptyTemplate: 'empty-collection-template'"></virtual-grid>
                </div>
            </div>
        </div>
        <div class="has-error" data-bind="visible: dataChanged()">
            <div class="help-block">
                <i class="icon-danger"></i><span>The data has changed. Your results may contain duplicates or stale entries. <a href="#" data-bind="click: refresh">Refresh.</a></span>
            </div>
        </div>
    </div>
</div>

${"<" + "script"} type="text/html" id="empty-collection-template">
    The revisions bin is empty.
${"<" + "/script"}>
<div class="tooltip json-preview js-revisions-bin-tooltip" style="opacity: 0">
    <pre><code></code></pre>
</div>
`;
// Exports
export default code;